import importedCookies from 'js-cookie';

let cookieSetSettings = {
    expires: 365
};

// Set default Cookie attributes (expiring, path, etc..)
const Cookies = importedCookies.withAttributes(cookieSetSettings);
const DEFAULT_CONSENT = {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'granted',
  personalization_storage: 'denied',
  security_storage: 'granted',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
}

function gtag(){dataLayer.push(arguments);}

if (window.drupalSettings && window.drupalSettings.db_cookies) {
    const { db_cookies } = window.drupalSettings;
    if (db_cookies.cookieAttributes) {
        const { cookieAttributes } = db_cookies;
        cookieSetSettings = { ...cookieSetSettings, ...cookieAttributes };
    }

    // Remove previous cookie
    if (!!Cookies.get('cookie_consent')) {
      Cookies.remove('cookie_consent');
    }
}



/**
 * Helpers for managing cookie consent preferences
 */
const COOKIE_NAME = 'cookie_consent_v2';

/**
 * Was consent shown?
 */
const getConsent = () => !!Cookies.get(COOKIE_NAME);

/**
 * Gets all settings
 * @returns {*}
 */
const getAll = () => {
    const all = Cookies.get(COOKIE_NAME);
    return all ? all.split(',') : [];
};

const fireEvent = (consent) => {
  const event = new CustomEvent('dbconsentupdate', {
    detail: consent
  });

  document.body.dispatchEvent(event);
}

/**
 * Accepts all cookies
 * @returns {*}
 */
const acceptAll = () => {
    const accept = {};
    for (const key of Object.keys(DEFAULT_CONSENT)) {
        accept[key] = 'granted';
    }
    Cookies.set(COOKIE_NAME, Object.keys(accept).join(','));
    gtag('consent', 'update', accept);
    fireEvent(accept);
};

/**
 * Decline all cookies
 * @returns {*}
 */
const declineAll = () => {
    Cookies.set(COOKIE_NAME, false);

    gtag('consent', 'update', DEFAULT_CONSENT);
    fireEvent(DEFAULT_CONSENT);
};

const close = () => {
  if (!getConsent()) {
    declineAll();
  }
};

/**
 * Save selected cookies values
 * @param values
 */
const save = (values) => {
  const accept = {};
  for (const key of Object.keys(values)) {
    if (values[key] === true) {
      accept[key] = 'granted';
    }
  }

  Cookies.set(COOKIE_NAME, Object.keys(accept).join(','));
  gtag('consent', 'update', accept);
  fireEvent(accept);
};

/**
 * Removes
 * @returns {Object|*|void|Promise<void>}
 */
const removeConsent = () => Cookies.remove(COOKIE_NAME);

export { getAll, acceptAll, declineAll, getConsent, removeConsent, save, close, gtag, DEFAULT_CONSENT };
